export default {
  "___contact-us_page-title": "",
  "contact-us_page-description": "We are here to help or answer your questions.",
  "contact-us_title_phone": "Call Us",
  "contact-us_title_hours": "Hours",
  "contact-us_title_address": "Mail Us",
  "contact-us_title_email": "Email Us",
  "contact-us_title_fax": "Fax a Claim",
  "contact-us_label_toll-free": "(toll free)",
  "contact-us_label_local": "(local)",
  "___contact-us_text_or": "",
  "contact-us_title_chat": "Chat",
  "contact-us_text_chat": "Chat hours: Monday through Friday, 8 AM to 5 PM Central Time",
  "contact-us_link_chat": "Start chat now",
};